(function () {

  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartDrawerOverlay');
  if (!drawer || !overlay) return;

  var closeBtn = document.getElementById('CartDrawerClose');
  var itemsEl = document.getElementById('CartDrawerItems');
  var countEl = document.getElementById('CartDrawerCountText');
  var totalEl = document.getElementById('CartDrawerTotal');
  var shippingEl = document.getElementById('CartDrawerShipping');
  var checkoutBtn = document.getElementById('CartDrawerCheckout');
  var noteToggle = document.getElementById('CartDrawerNoteToggle');
  var noteInput = document.getElementById('CartDrawerNoteInput');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  function renderCart(cart) {
    countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    totalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      checkoutBtn.disabled = true;
    } else {
      checkoutBtn.disabled = false;
      itemsEl.innerHTML = cart.items.map(function (item) {
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="cart-drawer__item-variant">' + item.variant_title + '</span>'
          : '';
        var compareHtml = item.original_line_price > item.line_price
          ? '<span class="cart-drawer__item-price-compare">' + money(item.original_line_price) + '</span>'
          : '';
        return (
          '<div class="cart-drawer__item" data-key="' + item.key + '">' +
            '<img src="' + item.image + '&width=160" alt="">' +
            '<div class="cart-drawer__item-info">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
              variantLine +
              '<div class="cart-drawer__item-bottom">' +
                '<div class="cart-drawer__item-qty">' +
                  '<button type="button" data-action="decrease">-</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-action="increase">+</button>' +
                '</div>' +
                '<button type="button" class="cart-drawer__item-remove" data-action="remove">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-drawer__item-price">' +
              '<span class="cart-drawer__item-price-current">' + money(item.line_price) + '</span>' +
              compareHtml +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
if (shippingEl) {
  shippingEl.textContent = 'Enjoy free shipping!';
  shippingEl.classList.add('is-visible');
}

  }

 function fetchCart() {
  return fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function(cart){

      renderCart(cart);

      document.querySelectorAll('[data-cart-count]').forEach(function(badge){

        if(cart.item_count > 0){

          badge.textContent = cart.item_count;
          badge.style.display = 'flex';

        }else{

          badge.textContent = 0;
          badge.style.display = 'none';

        }

      });

      return cart;

    });
}

function changeItem(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(function (res) {
      return res.json();
    })
    .then(function(cart){

      renderCart(cart);

      // Update header cart badge
      document.querySelectorAll('[data-cart-count]').forEach(function(badge){

        if(cart.item_count > 0){

          badge.textContent = cart.item_count;
          badge.style.display = 'flex';

        }else{

          badge.textContent = 0;
          badge.style.display = 'none';

        }

      });

      return cart;

    });
}

  // Quantity/remove buttons inside the drawer (event delegation)
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-action]');
    if (!btn) return;
    var itemEl = btn.closest('.cart-drawer__item');
    var key = itemEl.dataset.key;
    var qtySpan = itemEl.querySelector('.cart-drawer__item-qty span');
    var currentQty = parseInt(qtySpan.textContent, 10);

    if (btn.dataset.action === 'increase') {
      changeItem(key, currentQty + 1);
    } else if (btn.dataset.action === 'decrease') {
      changeItem(key, Math.max(0, currentQty - 1));
    } else if (btn.dataset.action === 'remove') {
      changeItem(key, 0);
    }
  });

  // Order note
  if (noteToggle) {
    noteToggle.addEventListener('click', function () {
      var visible = noteInput.style.display !== 'none';
      noteInput.style.display = visible ? 'none' : 'block';
      if (!visible) noteInput.focus();
    });
  }
  if (noteInput) {
    var noteTimer;
    noteInput.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        });
      }, 500);
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  // Open the drawer whenever the header's cart icon is clicked
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(openDrawer);
    });
  });

  // Intercept any "Add to Cart" form on the site (product page, quick-add, etc.)
  // so adding a product opens the drawer instead of navigating to /cart.
  // document.addEventListener('submit', function (e) {
  //   var form = e.target;
  //   if (!(form instanceof HTMLFormElement)) return;
  //   if (form.getAttribute('action') !== '/cart/add' && !form.action.endsWith('/cart/add')) return;

  //   e.preventDefault();
  //   var formData = new FormData(form);

  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: { Accept: 'application/json' },
  //     body: formData
  //   })
  //     .then(function (res) { return res.json(); })
  //     .then(function () {
  //       return fetchCart();
  //     })
  //     .then(openDrawer)
  //     .catch(function (err) {
  //       console.error('Add to cart failed:', err);
  //     });
  // });

  // Expose for manual triggering elsewhere if needed
  window.CartDrawer = { open: function () { fetchCart().then(openDrawer); }, close: closeDrawer, refresh: fetchCart };
})();